import { isBasicAuthStep } from '@bugbug/core/types/steps';

import type { Step } from '@bugbug/core/types/steps';

export const isBasicAuthVisible = (step: Step) =>
  isBasicAuthStep(step) && Boolean(step.username || step.password);
